module.exports = __webpack_public_path__ + "static/media/boomer_items.ac0f5567.png";